import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { TargetGroupViewModel } from "@playcharge/common/models/backend/target-groups/target-group-view-model";
import { Observable } from "rxjs";
import { ApiUtils } from "../utils/api-utils";
import { ApiRoutes } from "../models/constants/api-routes";
import { TargetGroupEditModel } from "@playcharge/common/models/backend/target-groups/target-group-edit-model";

@Injectable({
    providedIn: "root",
})
export class ApiTargetGroupsService {
    private _httpClient = inject(HttpClient);

    public getAll(): Observable<TargetGroupViewModel[]> {
        return this._httpClient.get<TargetGroupViewModel[]>(
            ApiUtils.buildUrl(ApiRoutes.targetGroups.root),
        );
    }

    public getById(targetGroupId: number): Observable<TargetGroupViewModel> {
        return this._httpClient.get<TargetGroupViewModel>(
            ApiUtils.buildUrl(
                ApiRoutes.targetGroups.targetGroup,
                new Map<string, string>([["groupId", targetGroupId.toString()]]),
            ),
        );
    }

    public create(model: TargetGroupEditModel): Observable<TargetGroupViewModel> {
        return this._httpClient.post<TargetGroupViewModel>(
            ApiUtils.buildUrl(ApiRoutes.targetGroups.root),
            model,
        );
    }

    public update(model: TargetGroupEditModel): Observable<TargetGroupViewModel> {
        return this._httpClient.put<TargetGroupViewModel>(
            ApiUtils.buildUrl(ApiRoutes.targetGroups.root),
            model,
        );
    }
}
